import React from "react";
import {AdjustRent} from "../../components/adjust-rent/AdjustRent";

export const AdjustRentView: React.FunctionComponent = () => {
  return <AdjustRent />;
};
